import * as fns from './fns'

export const DOM = {
  initialize () {
    console.log('DEBUG (DOM) Initializing DOM functions.')
    const head = (document.head || document.getElementsByTagName('head')[0])
    return {
      fns,
      elements: {
        byID: {},
        byClass: {},
        head: head,
        querySelector: {},
        querySelectorAll: {}
      },
      head: head
    }
  }
}